import { forwardRef } from "react";
 
import React from "react";

const BANNER_STYLE_ID = "sticky-banner-inline-styles";
const classes = {
  root: "stickyBanner_root",
  hidden: "stickyBanner_hidden",
  inner: "stickyBanner_inner",
  contentGroup: "stickyBanner_contentGroup",
  iconCol: "stickyBanner_iconCol",
  iconContainer: "stickyBanner_iconContainer",
  text: "stickyBanner_text",
  label: "stickyBanner_label",
  closeBtn: "stickyBanner_closeBtn",
};

const BANNER_STYLES = `
.${classes.root} {
  position: fixed;
  bottom: 0;
  left: 50%;
  width: 100%;
  max-width: var(--contentWidth, 1440px);
  z-index: 100;
  background-color: #dff3f9;
  transform: translateX(-50%) translateY(0);
  transition: transform 0.3s ease;
}

.${classes.root}.${classes.hidden} {
  transform: translateX(-50%) translateY(100%);
}

.${classes.inner} {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1pc;
  padding-top: 24px;
  padding-bottom: 24px;
  padding-left: 16px;
  padding-right: 16px;
 
  min-height: 100px;
  box-sizing: border-box;
}

.${classes.contentGroup} {
  display: flex;
  align-items: flex-start;
  gap: 1pc;
  max-width: 82%;
}

.${classes.iconCol} {
  width: 24px;
  flex-shrink: 0;
}

.${classes.iconContainer} {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #066086;
}

.${classes.text} {
  flex: 1;
  font-size: 11pt;
}

.${classes.text} a {
  display: inline;
  font-weight: bold;
  color: #0c55b8;
  text-decoration: underline;
}

.${classes.text} a:hover {
  color: #000000;
  text-decoration: none;
}

.${classes.label} {
  color: #0c55b8;
}

.${classes.closeBtn} {
  flex-shrink: 0;
  padding: 0;
  background: unset;
  border: unset;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  position: relative;
  transition: all 0.25s ease-out;
}

.${classes.closeBtn} svg {
  display: none;
}

.${classes.closeBtn}::before,
.${classes.closeBtn}::after {
  background-color: #3d3c38;
  content: "";
  display: block;
  height: 2px;
  width: 20px;
  position: absolute;
  opacity: 1;
  transform: rotate(-45deg);
  transition: all 0.25s ease-out;
}

.${classes.closeBtn}::after {
  transform: rotate(-135deg);
}

.${classes.closeBtn}:hover::before,
.${classes.closeBtn}:hover::after {
  transform: rotate(0deg);
}

.${classes.closeBtn}:focus-visible {
  outline: 2px solid #0c55b8;
  outline-offset: 2px;
}

@media (max-width: 768px) {
  .${classes.contentGroup} {
    max-width: 100%;
  }

  .${classes.iconCol} {
    display: none;
  }
}
`;







const StickyBanner = forwardRef(function StickyBanner({  }, ref) {
  React.useEffect(() => {
    if (document.getElementById(BANNER_STYLE_ID)) {
      return;
    }

    const styleTag = document.createElement("style");
    styleTag.id = BANNER_STYLE_ID;
    styleTag.textContent = BANNER_STYLES;
    document.head.appendChild(styleTag);

    return () => {
      if (styleTag.parentNode) {
        styleTag.parentNode.removeChild(styleTag);
      }
    };
  }, []);

  
 
  const [visible, setBannerVisible] = React.useState(() => {
    const storedValue = localStorage.getItem("consentBannerClosed");
    return storedValue !== "1";
  });
 const hideBanner = () => {
              localStorage.setItem("consentBannerClosed", "1");
              setBannerVisible(false);
              requestAnimationFrame(() => document.body.focus());
};

  
  const onClose = () => {
    hideBanner();
  };


  

  
  
  
  return (
    <div ref={ref} className={`${classes.root}${!visible ? ` ${classes.hidden}` : ""}`} aria-hidden={!visible} role="region" aria-label="Data use notice" aria-live="polite">
      <div>
        <div className={classes.inner}>
          <div className={classes.contentGroup}>
            <div className={classes.iconCol}>
              <div className={classes.iconContainer}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" focusable="false" aria-hidden="true">
                  <path d="M14.4 6L14.2 4.8C14.1 4.3 13.7 4 13.2 4H6C5.4 4 5 4.4 5 5V20C5 20.5 5.4 21 6 21C6.6 21 7 20.5 7 20V14H12.6L12.8 15.2C12.9 15.7 13.3 16 13.8 16H19C19.5 16 20 15.6 20 15V7C20 6.4 19.5 6 19 6H14.4Z" fill="currentColor" />
                </svg>
              </div>
            </div>
            <span className={classes.text}>
              <strong className={classes.label}>Data use:</strong>{" "}
              We use cookies and similar tools to make your use of this website easy and to keep it working properly. We may share data about you and how you use the site with third parties, such as analytics and marketing partners. Learn more in our{" "}
              <a href="https://www.optum.com/en/privacy-policy.html" target="_blank" rel="noreferrer" aria-label="Privacy Policy (opens in new tab)">Privacy Policy</a>
              {" "}and{" "}
              <a href="https://www.optum.com/en/terms-of-use.html" target="_blank" rel="noreferrer" aria-label="Terms of Use (opens in new tab)">Terms of Use</a>
              . By continuing to use the site, you agree to this.
            </span>
          </div>
          <button className={classes.closeBtn} onClick={onClose} aria-label="Close" />
        </div>
      </div>
    </div>
  );
});

export default StickyBanner;
